import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Page from "../../components/Page";
import device from "../../assets/device.png";
import "./styles.css";
import gif1 from "../../assets/home.gif";
import InputField from "../../components/inputField";
import ReCAPTCHA from "react-google-recaptcha";
import routeNames from "../../routes/routeNames";
import { useForm } from "@mantine/form";
import { backendUrl } from "../../constants";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import GoogleSignIn from "../../components/googleSignInComponent";

const Index = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [agree, setAgree] = useState();

  //for role_id
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}roles/listRoles`, options)
      .then((response) => response.json())
      .then((response) => {
        let role = response.data.filter((obj) => obj.name === "JobSeeker")[0]
          ._id;
        setRole(role);
      })

      .catch((err) => console.error(err));
  }, []);

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      zip: "",
      pass: "",
      rePass: "",
    },

    // functions will be used to validate values at corresponding key
    validate: {
      firstName: (value) =>
        value?.length < 1 ? "Please enter first name" : null,
      lastName: (value) =>
        value?.length < 1 ? "Please enter last name" : null,
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      pass: (value) =>
        value?.length < 8 ? "Password must at least have 8 characters" : null,
      rePass: (value, values) =>
        value !== values?.pass ? "Passwords did not match" : null,
    },
  });

  const handleSignUp = (values) => {
    let obj = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      password: values.pass,
      zipCode: values.zip,
      companyName: values.company,
      role: role,
    };
    if (agree) {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(obj),
      };
      fetch(`${backendUrl}user/addUser`, options)
        .then((response) => response.json())
        .then((response) => {
          showNotification({
            title: "Signed Up",
            message: "You have signed up as a job seeker successfuly!",
            color: "green",
          });
          navigate(routeNames.general.login);
        })
        .catch((err) => console.error(err));
    } else {
      showNotification({
        title: "Error",
        message: "Please agree to the terms and conditions!",
        color: "red",
      });
    }
  };

  return (
    <Page className="landing-page">
      <div className="main">
        <form
          onSubmit={form.onSubmit((values) => handleSignUp(values))}
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="mainContent2">
            {/* <div className="topim col-md-6">
              <h2>
                Create a <b>Free Profile</b>
              </h2>
              <p>
                Sign up for a free profile to view this job, be able to search
                unlimited jobs and get found by employers.
              </p>
              <img src={gif1} className="mainImage shadow rounded" />
            </div> */}
            <div className="topim2">
              <div className="formm2">
                <div className="d-flex gap-2 flex-column w-100">
                  <h3 className="text-dark text-center">
                    Create Your Free Account
                  </h3>
                  <InputField
                    placeholder={"First Name"}
                    width="100%"
                    form={form}
                    validateName="firstName"
                  />
                  <InputField
                    placeholder={"Last Name"}
                    className="m"
                    width="100%"
                    form={form}
                    validateName="lastName"
                  />
                  <InputField
                    placeholder={"Enter Email"}
                    className="m"
                    type="email"
                    width="100%"
                    form={form}
                    validateName="email"
                  />
                  <InputField
                    placeholder={"Enter Password"}
                    className="m"
                    type="password"
                    width="100%"
                    form={form}
                    validateName="pass"
                  />
                  <InputField
                    placeholder={"Re-Enter Password"}
                    className="m"
                    type="password"
                    width="100%"
                    form={form}
                    validateName="rePass"
                  />
                </div>
              </div>
              <div className="d-flex flex-column">
                <div
                  className="captcha"
                  style={{
                    transform: "scale(0.75)",
                    transformOrigin: "10px 25px",
                  }}
                >
                  <ReCAPTCHA sitekey="Your client site key" />
                </div>
                <div class="form-check">
                  <input
                    className="form-check-input bg-danger border-white"
                    type="checkbox"
                    value={agree}
                    id="flexCheckChecked"
                    onChange={(v) => setAgree(v.target.checked)}
                  />
                  <label
                    className="form-check-label text-black"
                    for="flexCheckChecked"
                  >
                    I agree to the{" "}
                    <a href={routeNames.general.terms} className=" text-dark">
                      terms and conditions
                    </a>
                    .
                  </label>
                </div>
              </div>
              <div className="align-items-center d-flex flex-column gap-2">
                <Button
                  title={"Create FREE Job Seeker Account"}
                  primary={true}
                  disable={false}
                  fontWeight="700"
                  type="submit"
                  width="100%"
                />
                {role && <GoogleSignIn type={role} />}
                {/* <Button
                  title={"Sign in with Facebook"}
                  icon={"fb"}
                  fontWeight="700"
                  type="submit"
                  width="90%"
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    backgroundColor: "rgb(12, 80, 170)",
                    color: "white",
                  }}
                /> */}
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="employer1">
        <h2 className="mt-1 mb-4 text-center text-dark">
          Build Your Own Profile
        </h2>
        <div className="jobSeeker">
          <div className="jobContent">
            <ul style={{ fontSize: "20px" }}>
              <li>
                Build a profile that will be matched with millions of jobs!
              </li>
              <li>Create your video resume!</li>
              <li>Search & Apply for unlimited jobs!</li>
              <li>Interactive back-end analytics!</li>
              <li>Network with your peers and advance your career!</li>
            </ul>
          </div>
          <img src={device} className="sideImage" />
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
